// extracted by mini-css-extract-plugin
export default {"imageWrapper":"nJ-z","hovered":"oJ-z","hoverImage":"pJ-z","mainImage":"qJ-z","imageNoBackground":"rJ-z","fullSizeImage":"sJ-z"};